<template>
    <div>
        <el-card>
            <div class="tableBox">
                <div>
                    <div>
                        <span>特殊统计</span>
                        <span>服务级别管理SLA统计</span>
                    </div>
                    <img src="../../../../assets/icon_logo.png">
                </div>
                <div>
                    <div>
                        <div style="position:relative;height:20px;">
                            <div class="helpDiv" style="position: absolute;top:-20px">
                                <b class="helpI"></b>
                                <a href="https://wiki.autoai.com/pages/viewpage.action?pageId=26156905"
                                target="_blank"
                                class="helpA">
                                    帮助指引
                                </a>
                            </div>
                        </div>
                        <el-form :inline="true" class="search-form">
                            <el-form-item label="">
                                <el-date-picker
                                    ref="dataPicker"
                                    @change="changeData"
                                    v-model="value"
                                    type="daterange"
                                    range-separator="至"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期"
                                    value-format="yyyy-MM-dd">
                                </el-date-picker>
                            </el-form-item>
                            <el-button type="primary" @click="selectData">修改时间</el-button>
                            <el-button type="primary" @click="getExcel">导出excel</el-button>
                        </el-form>
                    </div>
                    <div class="tableClass">
                        <div>
                            <el-table
                                :data="tableData">
                                <el-table-column prop="normal" label="正常完成个数"></el-table-column>
                                <el-table-column prop="overtime" label="超时完成个数"></el-table-column>
                                <el-table-column prop="incomplete" label="未完成个数"></el-table-column>
                                <el-table-column prop="total" label="请求总数"></el-table-column>
                                <el-table-column prop="rate" label="SLA完成率"></el-table-column>
                            </el-table>
                        </div>
                        <div ref="myChart"></div>
                    </div>
                </div>
                <div>
                    <div>
                        <span>生成时间:</span>
                        <span>{{getMes.generateTime}}</span>
                    </div>
                    <span>itsmops.autoai.com</span>
                </div>
            </div>
        </el-card>
    </div>
</template>

<script>

    import services from '../report.service';
    import { export_json_to_excel } from '../../../../core/utils/Export2Excel';
    export default {
        data: function () {
            return {
                tableData: [],
                value:'',
                options:{
                    tooltip : {
                        trigger: 'item',
                        formatter: function(params, ticket, callback){
                            return params.data[0]+'='+params.data[1]+'('+params.percent+'%)';
                        }
                    },
                    legend: {},
                    dataset:{},
                    series: [
                        {
                            type:'pie',
                            label: {
                                normal: {
                                    formatter:function(params){
                                        return params.data[0]+'='+params.data[1]+'('+params.percent+'%)';
                                    },
                                }
                            },
                        },
                    ]
                },
                getMes:{},
            }
        },
        mounted(){
            this.value = services.getDefaultData();
            this.getData();
        },
        methods:{
            getExcel(){
                let header = [];
                let filterVal = [];
                header = ['正常完成个数', '超时完成个数', '未完成个数', '请求总数', 'SLA完成率'];
                filterVal = ['normal', 'overtime', 'incomplete', 'total', 'rate'];
                const list = this.tableData;
                const data = this.formatJson(filterVal, list);
                export_json_to_excel({header,data,filename:`服务级别管理SLA统计${this.value[0]}—${this.value[1]}`});
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },
            getData(){//获取数据
                let params = {
                    startTime: this.value[0],
                    stopTime: this.value[1],
                }
                services.getEventManageList(params).then(res=>{
                    res.graphData.unshift(["product","正常完成个数"]);
                    res.tableData.forEach(item=>{
                        // item.rate = services.translateNum(item.rate,2)
                        // item.rate = (Number(item.rate).toFixed(4)*100)+'%'
                        item.rate=(item.rate*100).toFixed(2)+'%'
                    })
                    this.getMes = res;
                    this.tableData = res.tableData;
                    this.getEcharts();
                })
            },
            selectData(){//点击修改日期 日期控件自动聚焦
                let selData = this.$refs.dataPicker;
                selData.focus();
            },
            changeData(){//选择日期
                this.getData();
            },
            getEcharts(item){//实例化图标
                let myChart = this.$echarts.init(this.$refs.myChart);
                this.options.dataset.source = this.getMes.graphData;
                myChart.setOption(this.options);
            },
        }
    }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    .tableClass{
        display: flex;
        &>div:nth-child(1){
            width: 40%;
        }
        &>div:nth-child(2){
            width: 60%;
            height:400px;
        }
    }
</style>
